import { ReporterSilo } from '@/apiClient'
import { useQueryParams } from '@/hooks/useQueryParams'

// In the URL, so going back from an event's detail returns to the same view.
const SILO_QUERY_PARAM = 'silo'

export const useAdminCalendarSilo = () => {
  const queryParams = useQueryParams()

  const silo: ReporterSilo =
    queryParams.get(SILO_QUERY_PARAM) === ReporterSilo.court_reporter
      ? ReporterSilo.court_reporter
      : ReporterSilo.digital_reporter

  return {
    silo,
    setSilo: (silo: ReporterSilo) => queryParams.set(SILO_QUERY_PARAM, silo),
  }
}
